import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { EmployeeBoardUpdateShiftPage } from './employee-board-update-shift.page';

const routes: Routes = [
  {
    path: '',
    component: EmployeeBoardUpdateShiftPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EmployeeBoardUpdateShiftPageRoutingModule {}
